module.exports = __webpack_public_path__ + "static/img/limit_white_06.a9290a61.svg";